module.exports = __webpack_public_path__ + "static/main3-c5c6f22710c118aaa5dd7741fffc9256.png";